/** Общие константы и типы юридических документов сервиса. */

export const SERVICE = "«Любить по-russки» (forruss.ru)";
export const CONTACT = "support@forruss.ru";

/** Оператор персональных данных — АО «КПД». */
export const OPERATOR = "Акционерное общество «КПД»";
export const OPERATOR_SHORT = "АО «КПД»";
export const INN = "9722098859";
export const KPP = "772901001";
export const OGRN = "1257700237453";
export const LEGAL_ADDRESS = "119285, г. Москва, пр-кт Генерала Дорохова, д. 49";
export const CEO = "Габсаматова Ирина Фёдоровна";

export type LegalSection = { title: string; body: string[] };

export type LegalDoc = {
    /** Заголовок страницы документа. */
    title: string;
    /** Название в списке «Другие документы» (в строчном регистре, для середины предложения). */
    linkLabel: string;
    /** Публичный роут документа. */
    path: string;
    /** Дата редакции, как отображается на странице. */
    updated: string;
    sections: LegalSection[];
};
